export default __webpack_public_path__ + "static/media/293.e1ce86b0.jpg";